import { Component, OnInit } from "@angular/core";
import { authenticationService } from "src/app/Services/Authentication/authentication.service";
import { ViewController } from "@ionic/core";
import { PopoverController, ModalController, NavParams } from "@ionic/angular";
import { SharedService } from "src/app/Services/sheared/sharedService.service";
import { Router } from "@angular/router";
import { CotationService } from "src/app/Services/Cotation/cotation.service";
import { FactoryService } from "src/app/Services/historique/factory.service";
import { ResumeComponent } from "src/app/Components/resume/resume.page";

@Component({
  selector: "app-SouscategorieComponent",
  templateUrl: "./souscategorie.component.html",
  styleUrls: ["./souscategorie.component.scss"],
})
export class SouscategorieComponent implements OnInit {
  menu: boolean;
  objetpass: any[] = [];
  isEnabled: boolean;
  private sous_garanties;
  vehiculeSelected: any;
  constructor(
    private viewCtrl: PopoverController,
    private _router: Router,
    private modalcontroller: ModalController,
    private nvparms: NavParams,
    private facto: FactoryService,
    private _cotationService: CotationService
  ) {
    this.vehiculeSelected = this.nvparms.get("value");
    this.sous_garanties = this.vehiculeSelected.sous_cat;
    for (const key in this.vehiculeSelected.sous_cat) {
      if (this.vehiculeSelected.sous_cat.hasOwnProperty(key)) {
        const element = this.vehiculeSelected.sous_cat[key];
        this.objetpass.push(element);
      }
    }
  }

  ngOnInit() {
    this.isEnabled = false;
  }

  async onCloseModal() {
    this.modalcontroller.dismiss();
  }
  async onNext() {
    if (
      typeof this.vehiculeSelected.sous_cat === "number" ||
      typeof this.vehiculeSelected.sous_cat === "string"
    ) {
      
      this.facto.setData(150, this.vehiculeSelected);
      this.modalcontroller.dismiss();

      let timer = setTimeout(async () => {
        const resume = await this.modalcontroller.create({
          component: ResumeComponent,
          // cssClass:'garantie-modal',
          componentProps: {
            value: "guide",
          },
        });
        await resume.present();
        clearTimeout(timer);
      });
    }
  }
  onSelect(event) {
    this.vehiculeSelected.Libelle_Sous_cat = this.sous_garanties.find(
      (e) => e.Code_Sous_cate === event.target.value
    ).Libelle_Sous_cat;
    this.vehiculeSelected.sous_cat = event.target.value;
    this.isEnabled = true;
  }
  // onHistorique() {
  //   if (this._cotationService.navig.value == "/") {
  //     this._router.navigate(["cotationhistorique"]);
  //   } else {
  //     this._router.navigate(["/home/menu/cotationhistorique"]);
  //   }

  //   this.viewCtrl.dismiss();
  // }
  // onResponse() {
  //   if (this._cotationService.navig.value == "/") {
  //     this._router.navigate(["cotationresponse"]);
  //   } else {
  //     this._router.navigate(["/home/menu/cotationresponse"]);
  //   }

  //   //
  //   this.viewCtrl.dismiss();
  // }
}
